/** Read all pages before replacing the account list: no partial-list success. */
export async function fetchPocketAccounts(axios) {
  const accounts = [];
  for (let offset = 0; ; offset += 100) {
    const res = await axios.post('GetKeyts', { no_loader: true, data: { limit: 100, offset } });
    const body = res.data?.body;
    const page = body?.tables?.keyts?.colvalues;
    if (res.data?.error || Number(body?.result) !== 0 || !Array.isArray(page)) throw new Error('Account list unavailable');
    accounts.push(...page);
    if (page.length < 100) return accounts;
  }
}

/** SelectSimple renders labels with v-html; account and Pocket names are text. */
export function pocketOptionLabel(value) {
  return String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
}
